export default {
  errors: null,
  products: [],
  loading: false,
  searchMultiselect: []
};
